import React, { useEffect, useRef, useState } from "react";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Link as RouterLink } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ExploreIcon from "@mui/icons-material/Explore";
import GroupIcon from "@mui/icons-material/Group";
import CategoryIcon from "@mui/icons-material/Category";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import MapIcon from "@mui/icons-material/Map";
import ServicesIcon from "@mui/icons-material/Build";
import BookIcon from "@mui/icons-material/Book";
import NaturePeopleIcon from "@mui/icons-material/NaturePeople";
import ScheduleIcon from "@mui/icons-material/Schedule";
import FavoriteIcon from "@mui/icons-material/Favorite";
import AssessmentIcon from "@mui/icons-material/Assessment";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import BadgeIcon from "@mui/icons-material/Badge";
import MobileFriendlyIcon from "@mui/icons-material/MobileFriendly";
import PreviewIcon from "@mui/icons-material/Preview";
import PolicyIcon from "@mui/icons-material/Policy";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import { Box, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import AppSettingsAltIcon from "@mui/icons-material/AppSettingsAlt";
import { DRAWER_WIDTH } from "../utils/constants";
import TableViewIcon from "@mui/icons-material/TableView";
import { ExpoTheme } from "../themes/ExpoTheme";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import EmailIcon from "@mui/icons-material/Email";
import DynamicFormIcon from "@mui/icons-material/DynamicForm";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import GrassIcon from "@mui/icons-material/Grass";
import { useTheme } from "@emotion/react";
import StorageIcon from "@mui/icons-material/Storage";
import useGetEventSettings from "../hooks/useGetEventSettings";
const menuItems = [
  {
    text: "Dashboard",
    link: "/home",
    icon: <DashboardIcon />,
  },
  {
    text: "OES Forms",
    link: "/home/oes-forms",
    icon: <TableViewIcon />,
  },

  {
    text: "Visitor Form",
    link: "#",
    icon: <DynamicFormIcon />,
    subcategories: [
      {
        text: "Create the Form",
        link: "https://builder.expoplanner.in/reg-form-builder",
        icon: <DriveFileRenameOutlineIcon />,
      },
      {
        text: "Settings",
        link: "https://builder.expoplanner.in/reg-template",
        icon: <SettingsIcon />,
      },
      {
        text: "Preview",
        link: "https://imtex-forming2026-registration.expoplanner.in/visitor-registration",
        icon: <PreviewIcon />,
      },
      // {
      //   text: "Terms & Conditions",
      //   link: "/home/registration-terms-conditions",
      //   icon: <PolicyIcon />,
      // },
      // {
      //   text: "Badge Preview",
      //   link: "/home/registration-badge-preview",
      //   icon: <BadgeIcon />,
      // },
    ],
  },
  {
    text: "Floor Plan",
    link: "/home/floor-plan-creator",
    icon: <MapIcon />,
  },
  {
    text: "Exhibitors",
    link: "#",
    icon: <NaturePeopleIcon />,
    subcategories: [
      {
        text: "Exhibitor List",
        link: "/home/exhibitors-list",
        icon: <GroupIcon />,
      },
      {
        text: "Add Exhibitor",
        link: "/home/add-exhibitor",
        icon: <AddBusinessIcon />,
      },
    ],
  },
  // {
  //   text: "Email templates",
  //   link: "/home/email-block-editor",
  //   icon: <EmailIcon />,
  // },
  // {
  //   text: "Badge builder",
  //   link: "/home/badge-builder",
  //   icon: <BadgeIcon />,
  // },
  {
    text: "Mobile Apps",
    link: "/home/mobile-apps",
    icon: <MobileFriendlyIcon />,
  },
  {
    text: "Onsite Module",
    link: "/home/onsite-module",
    icon: <GrassIcon />,
  },
  {
    text: "Database",
    link: "/home/export-data",
    icon: <StorageIcon />,
  },
  {
    text: "Settings",
    link: "/home/settings",
    icon: <SettingsOutlinedIcon />,
  },
];

const SideMenuBar = ({ open, setOpen }) => {
  const { data } = useGetEventSettings();
  const theme = useTheme();
  const [openSubmenu, setOpenSubmenu] = useState({});
  const drawerRef = useRef(null); // Create a reference to the Drawer

  const handleClickSubmenu = (submenu) => {
    setOpenSubmenu((prevOpen) => ({
      ...prevOpen,
      [submenu]: !prevOpen[submenu],
    }));
    setOpen(true);
  };

  const renderMenuItems = (items, nestingLevel = 0) =>
    items.map((item) => {
      const paddingLeftUnits = open ? 2 + nestingLevel * 2 : 1;
      const listItem = (
        <ListItemButton
          onClick={() =>
            item.subcategories ? handleClickSubmenu(item.text) : null
          }
          component={item.link ? RouterLink : "button"}
          to={item.link || ""}
          sx={{
            paddingLeft: theme.spacing(paddingLeftUnits),
            paddingY: theme.spacing(open ? 1 : 1.5),
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: open ? 40 : "auto",
              justifyContent: "center",
            }}
          >
            {React.cloneElement(item.icon, {
              sx: {
                marginLeft: "7px",
              },
            })}
          </ListItemIcon>
          {open && <ListItemText primary={item.text} />}
          {item.subcategories ? (
            openSubmenu[item.text] ? (
              <ExpandLess fontSize="small" />
            ) : (
              <ExpandMore fontSize="small" />
            )
          ) : null}
        </ListItemButton>
      );

      return (
        <React.Fragment key={item.text}>
          {open ? (
            listItem
          ) : (
            <Tooltip title={item.text} placement="right">
              {listItem}
            </Tooltip>
          )}
          {item.subcategories && (
            <Collapse in={openSubmenu[item.text]} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {renderMenuItems(item.subcategories, nestingLevel + 1)}
              </List>
            </Collapse>
          )}
        </React.Fragment>
      );
    });

  useEffect(() => {
    if (open) {
      const handleClickOutside = (event) => {
        if (drawerRef.current && !drawerRef.current.contains(event.target)) {
          setOpen(false);
        }
      };

      document.addEventListener("mousedown", handleClickOutside);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [open, setOpen]);

  useEffect(() => {
    if (!open) {
      setOpenSubmenu({}); // Close all submenus
    }
  }, [open]);

  return (
    <Drawer
      ref={drawerRef} // Attach the reference here
      variant="permanent"
      sx={{
        width: open ? DRAWER_WIDTH : theme.spacing(7.6),
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: open ? DRAWER_WIDTH : theme.spacing(7.6),
          boxSizing: "border-box",
          overflowX: "hidden",
        },
      }}
      open={open}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <Box
          sx={{
            height: "64px",
            display: "flex",
            alignItems: "center",
            padding: "0 8px",
            justifyContent: open ? "flex-start" : "center",
            "@media (max-width: 600px)": {
              height: "56px",
            },
          }}
        >
          <IconButton onClick={() => setOpen(!open)}>
            {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
          {open && data && (
            <Box
              component="img"
              sx={{
                ml: 2,
                maxWidth: "100%",
                height: "56px",
              }}
              src={data?.eventLogo}
              alt="Logo"
            />
          )}
        </Box>
        <Divider />
        <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
          <List>{renderMenuItems(menuItems)}</List>
        </Box>
      </Box>
    </Drawer>
  );
};

export default SideMenuBar;
